import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Card, CardBody } from "reactstrap";
import { MdRefresh } from "react-icons/md";
import { getAllCardRequests } from "../../CardRequests/actions/cardrequests.actions";

const StatsCard = ({ dispatch, requests }) => {

  function fetchRequests() {
    dispatch(getAllCardRequests({ page: 1, pageSize: 10 }));
  }

  useEffect(() => {
    dispatch(getAllCardRequests({ page: 1, pageSize: 10 }));
  }, [dispatch]);

  return (
    <Card>
      <CardBody
        className={`dashboard__booking-card ${
          requests && requests.error ? "card-muted" : ""
        }`}
      >
        <div className="dashboard__booking-total-container">
          <h5 className="dashboard__booking-total-title dashboard__booking-total-title--red">
            <span
              className={`${requests && requests.error ? "text-muted" : ""}`}
            >
              {requests && requests.response ? requests.response.count : 0}
            </span>
          </h5>
          <MdRefresh
            className={`dashboard__trend-icon pointer  ${
              requests && requests.loading ? "spin" : ""
            } `}
            onClick={fetchRequests}
          />
        </div>
        <h4 className="dashboard__booking-total-description">
          Card Requests
          <br />
          <small>Total processed</small>
        </h4>
      </CardBody>
    </Card>
  );
};

export default connect(state => ({
  requests: state.getAllCardRequests
}))(StatsCard);
